import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';


const ButtonStyles = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Manrope", sans-serif;
  font-size: var(--font-size-base);
  font-weight: 700;
  border: none;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.3s ease, color 0.3s ease;

  ${(props) =>
    props.type === 'primary' &&
    css`
      background-color: var(--color-secondary);
      color: white;

      &:hover {
        background-color: var(--color-primary);
      }
      &:active {
        box-shadow: 0 0 5px var(--color-primary-dark);      
      }
    `}

  ${(props) =>
    props.type === 'secondary' &&
    css`
      border: 2px solid var(--color-secondary);;
      color: var(--color-secondary);
      font-weight: 600;
      background-color: transparent;

      &:hover {
        border: 2px solid var(--color-primary);
        color: var(--color-primary);       
      }
      &:active {
        box-shadow: 0 0 5px var(--color-primary-dark);      
      }
    `}

  ${(props) =>
    props.type === 'tertiary' &&
    css`
      background-color: var(--color-tertiary);
      color:var(--color-secondary);

      &:hover {
        background-color: var(--color-tertiary);
        color: var(--color-primary);
      }
      &:active {
        box-shadow: 0 0 5px var(--color-primary-dark);      
      }
    `}

  ${(props) =>
    props.size === 'small' &&
    css`
      width: 7rem;
      font-size: var(--font-size-xs);
      height: 32px;
    `}

  ${(props) =>
    props.size === 'medium' &&
    css`
      font-size: var(--font-size-base);
      height: 40px;
    `}

  ${(props) =>
    props.size === 'large' &&
    css`
      width: 20rem;
      font-size: var(--font-size-base);
      height: 48px;
    `}
    ${(props) =>
    props.size === 'volatile' &&
    css`
      width: 100%;
      font-size: var(--font-size-base);
      height: 48px;
    `}
`;
const StyledLink = styled.a`
  text-decoration: none;
`;

const HomePageButtonGeneral = ({ type, size, children, onClick, href, ...props }) => {
  if (href) {
    return (
      <StyledLink href={href} target={"_blank"} {...props}>
        <ButtonStyles type={type} size={size} onClick={onClick} href={href}>
          {children}
        </ButtonStyles>
      </StyledLink>
    );
  }
  return (
    <ButtonStyles type={type} size={size} onClick={onClick} href={href}>
      {children}
    </ButtonStyles>
  );
};

HomePageButtonGeneral.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

HomePageButtonGeneral.defaultProps = {
  type: 'primary',
  size: 'large',
  onClick: () => { },
};

export default HomePageButtonGeneral;
